const COMPANIES = [
    "briggs", "smidgens", "hilliard", "honda", "toyota", "cummins", "ansys", "kaiser", "mahany", "igus", "gleason", "magna", "altair", "harris", "gleason",
    "twmetals", "aurora", "koyo", "rstw", "polaris", "tekton", "sandvik", "niftybar", "wendys", "tacobell", "penske"
]

export default COMPANIES;